export default "__VITE_ASSET__55d97929__"